<div
	matTooltip="{{ errorText }}"
	matTooltipClass="pv-tooltip"
	matTooltipPosition="below"
	[class.disabled]="disabled"
	[formGroup]="form"
	[matTooltipDisabled]="!error"
>
	<input
		#input
		formControlName="value"
		type="text"
		[placeholder]="placeholder"
		(blur)="onBlurred()"
		(focus)="focusEvent.emit()"
		(input)="onChange()"
	/>
</div>
